/** Promotions in the web app: the promo code list and editor (Billing → Promotions). */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const editor = () => import('./PromoEditor.jsx');

export default {
  name: 'promotions',
  adminRoutes: [
    { path: 'billing/promotions', lazy: page(() => import('./Promotions.jsx'), 'Promotions') },
    { path: 'billing/promotions/new', lazy: page(editor, 'PromoEditor') },
    { path: 'billing/promotions/:uuid', lazy: page(editor, 'PromoEditor') },
  ],
  adminNav: [
    {
      section: 'billing_settings',
      to: '/admin/billing/promotions',
      label: 'Promotions',
      permission: 'admin.promotions.manage',
      order: 40,
    },
  ],
};
